
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'LungCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/LungCancer_TNM.vue